import { useDroppable } from '@dnd-kit/core'

type Props = {
  title: string
  sectionRefName: string
}

export const EmptySection = ({ title, sectionRefName }: Props) => {
  const { setNodeRef } = useDroppable({
    id: sectionRefName,
  })

  return (
    <div
      ref={setNodeRef}
      className="flex justify-center items-center h-[80px] bg-surface-backgroundElevated border border-dashed border-border-default-secondary rounded-sm"
    >
      <p className="font-EN-KR-body1-bold text-tb-blue-400">{title}</p>
    </div>
  )
}
